<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">日常辅助</Breadcrumb-item>
        <Breadcrumb-item>消息日志</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col span="6">
            <Form-item label="发送时间:">
              <DatePicker @on-change="atimeDateChange" format="yyyy-MM-dd HH:mm:ss" type="datetimerange"
                          placement="bottom-start" placeholder="" style="width: 100%"></DatePicker>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="模板名称">
              <Input placeholder="模糊搜素" name="params"
                     v-model="queryParam.params"></Input>
            </Form-item>
          </Col>
          <Col span="6">
            <Form-item label="消息内容">
              <Input placeholder="模糊搜素" name="params"
                     v-model="queryParam.adminKey"></Input>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col span="2">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/activity/message-log"
          :params="queryParam" :onLoading="onLoading" operator=""></List>
  </div>
</template>
<script>

export default {
  components: {},
  data: function () {
    let $constant = this.$constant
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      checkKeys: [],
      queryParam: {
        startTime: '',
        endTime: '',
      },
      statusList: $constant.enabledStatus,
      adminGroupList: null,
      departmentList: null,
      userList: null,
      title: [
        {
          title: '消息模板',
          align: 'center',
          key: 'templateName'
        },
        {
          title: '主题',
          align: 'center',
          key: 'title'
        },
        {
          title: '消息内容',
          width: 300,
          align: 'center',
          render: (h, params) => {
            let p = params.row.sendContent || ''
            let displayText = p.length > 50 ? p.substring(0, 50) + '...' : p
            if (displayText.length > 50) {
              return h('Poptip', {
                props: {
                  placement: 'right',
                  transfer: true,
                  wordWrap: true,
                  maxWidth: 500
                }
              }, [
                h('div', {
                  style: {
                    'white-space': 'pre-line',
                    'cursor': 'pointer'
                  }
                }, [
                  h('span', displayText),
                  h('br'),
                  h('span', {
                    style: {
                      color: '#2d8cf0'
                    }
                  }, '完整内容')
                ]),
                h('div', {
                  slot: 'content',
                  style: {
                    'white-space': 'pre-line',
                    'max-height': '500px',
                    'overflow-y': 'auto'
                  }
                }, p)
              ])
            }
            // 不超过5个句子，直接显示
            return h('div', {
              style: {
                'white-space': 'pre-line'
              }
            }, displayText)
          }
        },
        {
          title: '消息类型',
          align: 'center',
          key: 'msgTypeName'
        },
        {
          title: '接收人',
          align: 'center',
          key: 'sendToName'
        },
        {
          title: '发送结果',
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let result = row.sendResult
            let color = 'green'
            let text = 'success'

            if (result !== 'ok' && result !== '200') {
              color = 'red'
              text = result
            }

            return h('span', {
              style: {
                color: color,
              }
            }, text)
          }
        },
        {
          title: '时间',
          align: 'center',
          width: 180,
          key: 'createTime'
        },
      ]
    }
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    search () {
      this.reload = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
    },
    atimeDateChange (value) {
      this.queryParam.startTime = value[0]
      this.queryParam.endTime = value[1]
    },
  }
}

</script>

<style lang="less" scoped>
.btn-wrap {
  text-align: right;
  margin-top: 24px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// MessageLog.vue?dc58e4f2